import React, { useState, useContext, useEffect } from 'react'

import { Input, Modal, Form} from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import SL_Select from '../../components/selects/Select';
import { Option } from 'antd/lib/mentions';
import { ERegExp } from '../../enums/ERegExp';
import moment from 'moment';
import { displayMessage } from '../../services/helper';

const USER_TYPES = {
    ADMIN: 2,
    DENTIST: 3,
    MONITOR: 1
}

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function CreatePatient(props) {
    const [form] = Form.useForm()
    const [dentists, setDentists] = useState([])

    const {
        setShowLoading, user, windowHeight} = useContext(GeneralContext)

    useEffect(() => loadDentists(), [])

    const loadDentists = () => {
        setShowLoading(true)

        api.dentist.list().then(
            rs => {
                setDentists(rs.data)
                setShowLoading(false)
            }
        )
    }

    const handleCreatePatient = (values) => {
        setShowLoading(true)

        if (values.cpf) {
            if (values.cpf.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_CPF'), 'error')
                setShowLoading(false)
                return
            }
        }

        if (values.cell_phone_responsible) {
            if (values.cell_phone_responsible.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_PHONE'), 'error')
                setShowLoading(false)
                return
            }
        }

        if (values.cpf_responsible) {
            if (values.cpf_responsible.replace(/\D/g, "")?.length != 11) {
                alert(displayMessage('INVALID_RESPONSIBLE_CPF'), 'error')
                setShowLoading(false)
                return
            }
        }

        if (user.user_type == USER_TYPES.DENTIST) {
            values = {...values, dentist_id: user.id}
        }

        api.patient.create(values)
            .then(
                rs => {
                    alert(displayMessage('CREATE_PATIENT_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshPatients()
                    setShowLoading(false)
                    props.handleOnCloseModal()
                },
                err => {
                    setShowLoading(false)
                }
            )
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('CREATE_PATIENT')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <Form
                form={form}
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleCreatePatient}
                layout="vertical"
                requiredMark='optional'
            >
                <div className='font-bold text-lg text-appian-blue text-center'>
                    {displayMessage('PATIENT_DATA')}
                </div>

                <Form.Item
                    label={displayMessage('NAME')}
                    name="first_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('NAME_WARNING') },
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('NAME')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('LAST_NAME')}
                    name="last_name"
                    className={`w-full flex`}
                    rules={[
                        { required: true, message: displayMessage('FULL_NAME_MANDATORY') },
                        { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: true, message: displayMessage('SURENAME_WARNING') },
                    ]}                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('LAST_NAME')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('APP_LOGIN')}
                    name="login"
                    className={`w-full flex`}
                    rules={[
                        {whitespace: true, message: displayMessage('LOGIN_NOT_NULL_WARNING')},
                        {pattern: /^\S*$/, message: displayMessage('LOGIN_WHITSPACE_WARNING')},
                    ]}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('APP_LOGIN')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('APP_PASSWORD')}
                    name="password"
                    className={`w-full flex`}
                >
                    <Input
                        type="password"
                        size='large'
                        placeholder={displayMessage('PASSWORD') + displayMessage('PASSWORD_EXEMPLE')}
                        className={inputsClassName}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('CPF')}
                    name="cpf"
                    className={`w-full flex`}
                >
                    <MaskedInput
                        type="text"
                        size='large'
                        placeholder={displayMessage('CPF') + displayMessage('CPF_EXEMPLE')}
                        className={inputsClassName}
                        mask={'000.000.000-00'}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('BIRTHDAY')}
                    name="birth_date"
                    className={`w-full flex`}
                >
                    <SL_Date
                        className={inputsClassName}
                        placeholder={displayMessage('SELECT_DATE')}
                        style={{ width: '100%', height: 110 }}
                        format={'DD/MM/YYYY'}
                        disabledDate={(current) => {
                            let customDate = moment().format("YYYY-MM-DD");
                            return current && current >= moment(customDate, "YYYY-MM-DD");
                        }}
                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('IDENTIFICATOR_PATIENT')}
                    name="identificator_patient"
                    className={`w-full flex`}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('IDENTIFICATOR_PATIENT')}
                        className={inputsClassName}

                    />
                </Form.Item>
                <Form.Item
                    label={displayMessage('PHOTO')}
                    name="image_url"
                    className={`w-full flex`}
                >
                    <Input
                        type="text"
                        size='large'
                        placeholder={displayMessage('SET_IMAGE_LINK')}
                        className={inputsClassName}
                    />
                </Form.Item>

                <Form.Item
                    label={displayMessage('GENDER')}
                    name="gender"
                    className={`w-full flex`}
                >
                    <SL_Select
                        className={`w-full flex`}
                        placeholder={displayMessage('SELECT_OPTION')}
                    >
                        <Option value={1}>{displayMessage('MALE')}</Option>
                        <Option value={2}>{displayMessage('FEMALE')}</Option>
                        <Option value={3}>{displayMessage('OTHERS')}</Option>
                    </SL_Select>
                </Form.Item>

                {(user.user_type == USER_TYPES.ADMIN || user.user_type == USER_TYPES.MONITOR) ?
                    <Form.Item
                        label={displayMessage('DENTIST')}
                        name="dentist_id"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('DENTIST_MANDATORY')}]}
                    >
                        <SL_Select
                            className={`w-full flex`}
                            placeholder={displayMessage('SELECT_OPTION')}
                        >
                            {
                                dentists?.map(
                                    dentist => <Option value={dentist?.id}>{dentist?.first_name + " " + dentist?.last_name}</Option>
                                )
                            }
                        </SL_Select>
                    </Form.Item>
                    :
                    null
                }



                <div className='mt-1 font-bold text-lg text-appian-blue text-center' >
                    {displayMessage('RESPONSIBLE_DATA')}
                </div>

                <div className='flex flex-col mb-1'>
                    <Form.Item
                        label={displayMessage('NAME')}
                        name="first_name_responsible"
                        className={`w-full flex`}
                    >
                        <Input
                            type="text"
                            size='large'
                            placeholder={displayMessage('NAME')}
                            className={inputsClassName}
                        />
                    </Form.Item>
                    <Form.Item
                        label={displayMessage('LAST_NAME')}
                        name="last_name_responsible"
                        className={`w-full flex`}
                    >
                        <Input
                            type="text"
                            size='large'
                            placeholder={displayMessage('LAST_NAME')}
                            className={inputsClassName}

                        />
                    </Form.Item>
                    <Form.Item
                        label={displayMessage('CPF')}
                        name="cpf_responsible"
                        className={`w-full flex`}
                    >
                        <MaskedInput
                            type="text"
                            size='large'
                            placeholder={displayMessage('CPF') + displayMessage('CPF_EXEMPLE')}
                            className={inputsClassName}
                            mask={'000.000.000-00'}
                        />
                    </Form.Item>
                    <Form.Item
                        label={displayMessage('EMAIL')}
                        name="email"
                        className={`w-full flex`}
                    >
                        <Input
                            type="text"
                            size='large'
                            placeholder={displayMessage('EMAIL') + displayMessage('EMAIL_EXEMPLE')}
                            className={inputsClassName}

                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('PHONE_WHATSAPP')}
                        name="cell_phone_responsible"
                        className={`w-full flex`}
                    >
                        <MaskedInput
                            type="text"
                            size='large'
                            placeholder={displayMessage('TYPE_PHONE')}
                            className={inputsClassName}
                            mask={'(00) 00000-0000'}
                        />
                    </Form.Item>

                </div>

                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_PATIENT')}
                </SL_Button>
            </Form>
        </Modal >
    )
}